module.exports = __webpack_public_path__ + "img/number07.e0fdca67.svg";